export function isInDateRange(
  startDate: Date | string | null,
  endDate: Date | string | null
): boolean {
  const now = Date.now();
  const start = new Date(startDate || -Infinity).getTime();
  const end = new Date(endDate || Infinity).getTime();
  return now > start && now < end;
}
